import PasswordInput from "@/components/PasswordInput";
import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Lock, CheckCircle, ArrowRight } from "@phosphor-icons/react";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw.length < 6) { setErr("Password must be at least 6 characters."); return; }
    if (pw !== confirm) { setErr("Passwords don't match."); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => nav("/login"), 2500);
    } catch (e) { setErr(formatApiError(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="bg-grain min-h-screen grid place-items-center px-5">
      <div className="card w-full max-w-md" data-testid="reset-password-card">
        {!token ? (
          <div className="text-center">
            <p className="text-[#B91C1C] font-semibold mb-2">This reset link is missing its token.</p>
            <Link to="/login" className="btn-primary inline-flex">Back to login</Link>
          </div>
        ) : done ? (
          <div className="text-center" data-testid="reset-success">
            <CheckCircle size={40} weight="fill" color="#84CC16" className="mx-auto mb-2" />
            <h2 className="text-2xl font-bold font-display mb-1">Password reset</h2>
            <p className="text-[#000000]">Taking you to the login page…</p>
          </div>
        ) : (
          <>
            <div className="flex items-center gap-2 mb-1">
              <Lock size={22} weight="duotone" color="#CCFF00" />
              <h2 className="text-2xl font-bold font-display">Set a new password</h2>
            </div>
            <p className="text-[#000000] text-sm mb-5">Choose a new password for your account.</p>
            <form onSubmit={submit} className="flex flex-col gap-3">
              <PasswordInput testid="reset-password-input" className="input-base"
                placeholder="New password" value={pw} onChange={(e) => setPw(e.target.value)} minLength={6} required />
              <PasswordInput testid="reset-password-confirm" className="input-base"
                placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} minLength={6} required />
              {err && <div data-testid="reset-password-error" className="text-[#FF5100] text-sm">{err}</div>}
              <button data-testid="reset-password-submit" type="submit" disabled={busy}
                className="btn-primary mt-1 flex items-center justify-center gap-2">
                {busy ? "Saving…" : "Reset password"} <ArrowRight size={18} weight="bold" />
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
